import { render, staticRenderFns } from "./FramePosition.vue?vue&type=template&id=e8eb0a00&"
import script from "./FramePosition.vue?vue&type=script&lang=js&"
export * from "./FramePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports